<script setup >
import { inject } from 'vue'
import stripslashes, {replaceS3path} from '@/Shared/helper.js'
const data = inject('data')
const brandDetailHTML = data.extra.brandDetailHTML.replace('<!-- FREE-HTML-AREA START -->', '').replace('<!-- FREE-HTML-AREA END -->', '').trim()

</script>

<template>
  <template v-if="brandDetailHTML">
    <div class="relative py-12 sm:px-16 md:py-20 lg:py-32 border-b-2 border-[#eee]">
      <div class="contentsContainer">
        <div class="brand-freehtml" v-html="stripslashes(replaceS3path(data.extra.brandDetailHTML))" />
      </div>
    </div>
  </template>
</template>